import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { RiLogoutCircleLine } from "react-icons/ri";
import EdsgLogo from "../../assets/images/ConnectHealthPro.png";
import { logout } from "../../utility/auth";
import aiLogo from "../../assets/images/Greezone-ai.png";
import { MessageOutlined } from "@mui/icons-material";
import { get } from "../../utility/fetchModule";
import { MdOutlineApps } from "react-icons/md";

/* --- Sidebar Accordion CSS --- */
const sidebarAccordionStyles = `
.sidebar-accordion-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
}
.sidebar-accordion-header {
  width: 100%;
  background: none;
  border: none;
  outline: none;
  display: flex;
  align-items: flex-start;
  font-weight: bold;
  padding: 10px 0 10px 10px;
  user-select: none;
  cursor: pointer;
  background: #f7faf7;
  border-radius: 4px;
  transition: background 0.2s;
}
.sidebar-accordion-header.open,
.sidebar-accordion-header:hover {
  background: #e6f4ea;
}
.sidebar-accordion-content,
.sub-menu {
  padding-bottom: 4px;
  display: block;
  padding-left: 24px;
  text-align: left;           /* Ensure left alignment */
}
.sidebar-accordion-content li,
.sub-menu li {
  padding: 6px 0 6px 8px;
  margin: 0;
  border: none;
  background: none;
  display: block;
  text-align: left;           /* Ensure left alignment */
}
.sidebar-accordion-content li a,
.sub-menu li a,
.menu-items > li > a,
.menu-items > li > .has-sub-menu {
  color: #788195;
  text-decoration: none;
  font-size: 14px;
  border-radius: 3px;
  transition: background 0.2s, color 0.2s;
  white-space: normal;        /* Allow full name wrapping */
  overflow: visible;          /* No truncation */
  text-overflow: unset;       /* No ellipsis */
  text-align: left;           /* Ensure left alignment */
}
.sidebar-accordion-content li a:hover,
.sub-menu li a:hover,
.menu-items > li > a:hover,
.menu-items > li > .has-sub-menu:hover {
  background: #f5f7f9;
  color: #017d34;
}
.menu-items > li.active > a,
.menu-items > li.active > .has-sub-menu {
  color: #017d34;
  font-weight: bold;
  background: #e6f4ea;
  border-radius: 4px;
}
`;

const Sidebar = ({ history, menuList }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
  const [moduleDetails, setModuleDetails] = useState([]);
  const [openAccordion, setOpenAccordion] = useState(null);

  useEffect(() => {
    const fetchModuleDetails = async () => {
      try {
        const clinicId = userInfo?.healthCareProviderId || 2;
        const userId = userInfo?.userId || 148;

        const response = await get({
          endpoint:
            "/medicalmodulerole/api/ModulesDetails/GetModuleStandAlone/GetModuleStandalone",
          pQuery: { clinicid: clinicId, userid: userId },
          auth: true,
        });

        if (response && response.data && response.data.data) {
          setModuleDetails(response.data.data);
        }
      } catch (error) {
        // fail silently
      }
    };

    fetchModuleDetails();
  }, [userInfo?.healthCareProviderId, userInfo?.userId]);

  return (
    <>
      <style>{sidebarAccordionStyles}</style>
      <nav className="page-sidebar">
        <div className="sidebar-header">
          <img
            src={EdsgLogo}
            alt="logo"
            className="brand"
            style={{ width: "100%" }}
            height={50}
          />
        </div>

        <div className="sidebar-menu">
          <ul className="menu-items">
            {/* First 2 items from menuList */}
            {menuList &&
              menuList
                .slice(0, 2)
                .map((item) => (
                  <MenuItem props={item} pathname={pathname} key={item.title} />
                ))}

            {/* Dynamic Module Menu Items (positions 3 to x) as Accordions */}
            {moduleDetails &&
              moduleDetails.length > 0 &&
              moduleDetails.map((category, categoryIndex) => (
                <li key={categoryIndex} className="sidebar-accordion-group">
                  <div
                    className={`sidebar-accordion-header pointer${
                      openAccordion === categoryIndex ? " open" : ""
                    }`}
                    onClick={() =>
                      setOpenAccordion(
                        openAccordion === categoryIndex ? null : categoryIndex
                      )
                    }
                  >
                    <MdOutlineApps className="icon" />
                    <span style={{ marginLeft: 8 }}>{category.category}</span>
                    <IoIosArrowBack
                      style={{
                        marginLeft: "auto",
                        transition: "transform 0.2s",
                        transform:
                          openAccordion === categoryIndex
                            ? "rotate(-90deg)"
                            : "rotate(0deg)",
                      }}
                    />
                  </div>
                  {openAccordion === categoryIndex &&
                    category.module &&
                    category.module.length > 0 && (
                      <ul className="sidebar-accordion-content">
                        {category.module.map((module, moduleIndex) => (
                          <li key={moduleIndex} className="pointer">
                            <a
                              href={`${module.address}${
                                module.address.includes("?") ? "&" : "?"
                              }isStandalone=true`}
                              rel="noopener noreferrer"
                            >
                              <span
                                className="title"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 0", // top and bottom padding
                                  margin: "4px 0", // optional: extra margin
                                }}
                              >
                                <MdOutlineApps style={{ marginRight: 8 }} />
                                {module.name}
                              </span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                </li>
              ))}

            {/* Remaining items from menuList (from position 3 onwards) */}
            {menuList &&
              menuList
                .slice(2)
                .map((item) => (
                  <MenuItem props={item} pathname={pathname} key={item.title} />
                ))}

            <li
              onClick={() => navigate("/doctor/feedback")}
              className="pointer"
              style={{ marginTop: "20px" }}
            >
              <MessageOutlined
                style={{ width: "24px", height: "24px", color: "#3C7E2D" }}
              />
              <span className="title m-l-20 text-wrap">Submit Feedback</span>
            </li>
            <div className="m-l-20 m-t-20">
              {/* <img src={aiLogo} alt="logo" className="brand m-l-20" width="150"></img> */}
            </div>
          </ul>
        </div>
      </nav>
    </>
  );
};

const MenuItem = ({ props: { title, href, icon, children }, pathname }) => {
  const [isShowingSub, setIsShowingSub] = useState(false);

  const isActive = pathname === href || pathname.startsWith(href);

  return (
    <>
      <li className={`sidebar-accordion-group${isActive ? " active" : ""}`}>
        <div
          className="sidebar-accordion-header pointer"
          style={{ padding: 0 }}
        >
          {icon}
          {children ? (
            <>
              <span
                className="has-sub-menu"
                onClick={() => setIsShowingSub(!isShowingSub)}
                style={{
                  cursor: "pointer",
                  padding: "10px 0 10px 10px",
                  flex: 1,
                }}
              >
                <span className="title">{title}</span>
              </span>
              <IoIosArrowBack
                className={`${isShowingSub ? "open" : ""} arrow`}
                style={{
                  transition: "transform 0.2s",
                  transform: isShowingSub ? "rotate(-90deg)" : "rotate(0deg)",
                }}
              />
            </>
          ) : (
            <Link
              to={href}
              className="has-sub-menu"
              style={{ flex: 1, padding: "10px 0 10px 10px" }}
            >
              <span className="title">{title}</span>
            </Link>
          )}
        </div>
        {children && isShowingSub && (
          <ul className="sub-menu">
            {children.map((sub) => {
              const isSubActive =
                pathname === sub.href || pathname.startsWith(sub.href);
              return (
                <li className={isSubActive ? "active" : ""} key={sub.title}>
                  <Link to={sub.href}>{sub.title}</Link>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    </>
  );
};

export default Sidebar;
